import styled, { css } from 'styled-components'
import { ReactComponent as Dots } from '../../../../assets/icons/three-dots.svg'
import { MenuItem } from '@material-ui/core'

export const Wrapper = styled.div`
  tbody > tr {
    cursor: pointer;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    width: auto;
    min-width: 200px;
    max-width: 235px;
    background-color: ${({ theme }) => theme.colors.lightSecondary};
    border-radius: 4px;
  }

  select {
    min-width: 150px;
  }

  @media (max-width: 1440px) {
    h2 {
      font-size: 2.3rem;
    }
  }
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;

  select {
    margin-top: 0;
  }

  button {
    margin-left: 8px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    button {
      margin-left: 0;
    }
  }
`

export const Calendar = styled.div`
  padding: 12px;
  border-radius: 5px;
  background-color: #e3eee2;
  margin-right: 12px;
`

export const InputContainer = styled.form`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 24px 12px;
  border-radius: 6px;
  margin-top: 40px;
  display: grid;
  grid-template-columns: 1fr 0.3fr;

  button {
    margin-left: 20px;
    width: auto;
  }
`

export const TableContainer = styled.div`
  margin-top: 40px;
`

export const TableHeaderFilters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`
export const EmmergencyFilter = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  label {
    font-size: ${({ theme }) => theme.font.sizes.small};
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
    margin-left: 8px;
  }

  @media (max-width: 1440px) {
    margin-left: 1rem;
  }
`

export const ActingSectors = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Pendencies = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EmergencyIndicator = styled.span`
  border-left: 3px solid #f48989;
  min-height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
`

export const EmergencyDescription = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.font.sizes.xxsmall};
  font-weight: 500;
  padding: 6px 4px;
  background-color: #f48989;
  border-radius: 6px;
`

export const Emergency = styled.span`
  padding: 7px 2px;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.lightRed};
  font-weight: ${({ theme }) => theme.font.black};
  font-size: ${({ theme }) => theme.font.sizes.xxsmall};
`

const Circle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 100px;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    transition: 0.5s;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
    color: ${({ theme }) => theme.colors.white};
    font-size: ${({ theme }) => theme.font.sizes.xxxsmall};

    &:not(:first-of-type) {
      margin-left: -4px;
    }
  }
`

export const Pendency = styled.div`
  div {
    background-color: ${({ theme }) => theme.colors.lightOrange};
  }
  ${Circle}
`

export const Sector = styled.div`
  div {
    background-color: ${({ theme }) => theme.colors.greyishBlue};
  }
  ${Circle}
`
export const DotsIcon = styled(Dots)`
  cursor: pointer;
  path {
    fill: #c0c0c0;
  }
`
export const StyledMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.colors.primary}!important;
  font-weight: ${({ theme }) => theme.font.bold}!important;
  border-radius: 8px !important;
  padding: 8px !important;
  margin-left: 8px !important;
  margin-right: 8px !important;

  span {
    margin-left: 8px;
  }

  circle {
    display: none;
  }

  &:hover {
    background-color: #e4f3e1 !important;
  }
`
